var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('md-card',{attrs:{"md-with-hover":""}},_vm._l((_vm.cardButtons),function(card){return _c("MenuButtonCard",{key:card.name,tag:"MenuButtonCard",attrs:{"name":card.name,"toRoute":card.toRoute}})}),1)}
var staticRenderFns = []

export { render, staticRenderFns }